import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Vendor/owlcarousel/owl.carousel.min';
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/collection/collection';
import 'Bem/site/collections-slider/collections-slider';
import { oLike } from 'Lib/like/like';

oLike.init('.js-book-like');
svgSpriteLoader('/site/dictionary/svg/sprite.svg?v=20180320');